import {
    axios as request
} from '@/utils/request2'
import qs from 'qs'
const headers = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8;',
}
const NODE_ENV = process.env.NODE_ENV
console.log("NODE_ENV", NODE_ENV)
// let mongouserBaseUrl = NODE_ENV!="prod" ?'https://tall.cpic.fun/mongouser-dev':'https://tall.cpic.fun/mongouser'
// console.log("NODE_ENV.mongouserBaseUrl",mongouserBaseUrl)

// const NODE_ENV = process.env.NODE_ENV
// //多环境API BaseUrl
// export const baseUrlMap = {
// 	'onlyuser': NODE_ENV != "prod" ? 'https://onlyuser-dev.cdqidian.net' : 'https://onlyuser.cdqidian.net',
// 	'billing': NODE_ENV != "prod" ? 'https://billing-dev.cdqidian.net' : 'https://billing.cdqidian.net',
// 	'tmk': NODE_ENV != "prod" ? 'https://test.cdqidian.net' : 'https://itms.cdqidian.net',
// 	'tmk2': NODE_ENV != "prod" ? 'https://test.cdqidian.net/itms' : 'https://itms.cdqidian.net/api',
// 	'tmk3': NODE_ENV != "prod" ? 'https://test.cdqidian.net' : 'https://backend.cdqidian.com',
// 	'mvidata': NODE_ENV != "prod" ? 'https://mvidata-dev.cdqidian.net' : 'https://mvidata.cdqidian.net',
// 	'mongouser': NODE_ENV != "prod" ? 'https://tall.cpic.fun/mongouser-dev' : 'https://tall.cpic.fun/mongouser',
// 	"app_tag": NODE_ENV != "prod" ? 'b710b4d3' : '59221ac2',
// }


const api = {

    //ip 管理
    official: '/official/',
    //证件照识别
    automatic:'/customer/automatic/'



};



export default api;




export async function official_get(params) {
    return request(api.official, {
        params,
    });
}

export async function official_post(params) {
    return request(api.official, {
        method: 'POST',
        data: params,
    });
}

export async function official_patch(id, params) {
    return request(api.official + id + '/', {
        method: 'PATCH',
        data: params,
    });
}

export async function official_delete(id) {
    return request(api.official + id + '/', {
        method: 'DELETE',
    });
}



export async function automatic_get(params) {
    return request(api.automatic, {
        params,
    });
}

export async function automatic_post(params) {
    return request(api.automatic, {
        method: 'POST',
        data: params,
    });
}

export async function automatic_patch(id, params) {
    return request(api.automatic + id + '/', {
        method: 'PATCH',
        data: params,
    });
}

export async function automatic_delete(id) {
    return request(api.automatic + id + '/', {
        method: 'DELETE',
    });
}



// WEBPACK FOOTER //
// ./src/api/account/myOrgs.js